import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tool-remove",
  "use": "tool-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"tool-remove\">\r\n<path d=\"M12.473 13.533c0.293 0.293 0.768 0.293 1.061 0s0.293-0.768 0-1.061l-4.596-4.596 4.596-4.596c0.293-0.293 0.293-0.768 0-1.061s-0.768-0.293-1.061 0l-4.596 4.596-4.596-4.596c-0.292-0.292-0.767-0.294-1.061 0-0.293 0.293-0.293 0.768 0 1.061l4.596 4.596-4.596 4.596c-0.293 0.293-0.293 0.768 0 1.061s0.768 0.293 1.061 0l4.596-4.596 4.596 4.596z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol